const decodeBase64Url = (subject) => {
  const cleansed = subject.replace(/-/g, "+").replace(/_/g, "/");
  return atob(`${cleansed}${"=".repeat((4 - (cleansed.length % 4)) % 4)}`);
};

export const getPermissionsFromToken = (token) => {
  if (!token) return [];

  try {
    const [, payload] = token.split(".");
    const tokenPayload = JSON.parse(decodeBase64Url(payload));
    return tokenPayload.permissions || [];
  } catch (error) {
    console.error("Error decoding token:", error);
    return [];
  }
};

export const hasAdminPermission = (token) => {
  const permissions = getPermissionsFromToken(token);
  return permissions.includes("view:takeback:all");
};

export const getTokenExpiration = (token) => {
  if (!token) return null;

  try {
    const [, payload] = token.split(".");
    const tokenPayload = JSON.parse(decodeBase64Url(payload));
    return tokenPayload.exp ? tokenPayload.exp * 1000 : null; // Convert to milliseconds
  } catch (error) {
    console.error("Error getting token expiration:", error);
    return null;
  }
};

// Default buffer time: 5 minutes (300 seconds)
// Can be overridden via REACT_APP_TOKEN_REFRESH_BUFFER_SECONDS env var
const DEFAULT_BUFFER_SECONDS =
  parseInt(process.env.REACT_APP_TOKEN_REFRESH_BUFFER_SECONDS) || 300;

export const isTokenExpired = (
  token,
  bufferSeconds = DEFAULT_BUFFER_SECONDS
) => {
  const expiration = getTokenExpiration(token);
  if (!expiration) return true; // If we can't determine expiration, assume expired

  // Add buffer to refresh slightly before expiration
  const bufferMs = bufferSeconds * 1000;
  return Date.now() >= expiration - bufferMs;
};

export const isValidTokenStructure = (token) => {
  if (!token || typeof token !== "string") return false;

  // JWT should have 3 parts separated by dots
  const parts = token.split(".");
  if (parts.length !== 3) return false;

  try {
    // Try to decode each part
    const [header, payload] = parts;
    JSON.parse(decodeBase64Url(header));
    JSON.parse(decodeBase64Url(payload));
    return true;
  } catch (error) {
    return false;
  }
};

export const validateRefreshToken = (refreshToken) => {
  // Add detailed logging for debugging
  console.log("Validating refresh token:", {
    exists: !!refreshToken,
    type: typeof refreshToken,
    length: refreshToken?.length,
    preview: refreshToken ? `${refreshToken.substring(0, 20)}...` : "N/A",
  });

  if (!refreshToken || typeof refreshToken !== "string") {
    return { valid: false, reason: "Missing or invalid refresh token" };
  }

  // WorkOS refresh tokens are opaque tokens, not JWTs
  // They don't follow the standard JWT structure, so we can't validate their structure
  // or check expiration client-side. We just check they exist and are non-empty.
  if (refreshToken.trim().length === 0) {
    return { valid: false, reason: "Empty refresh token" };
  }

  // For WorkOS tokens, we can't check expiration client-side
  // The server will tell us if it's expired when we try to use it
  return { valid: true };
};
